import { ReactNode } from 'react';

export interface ISectionContainerProps {
  children: ReactNode;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a container with all side padding
 */
export function SectionContainer({
  children,
}: Readonly<ISectionContainerProps>) {
  return <div className="grow pb-4">{children}</div>;
}
